import { Ethernet } from "react-bootstrap-icons";
import { serverUrl, getheader, setErrorDialog } from "./CommonFunctions";
//////////////////    
export function addService(data, fn) {
  const _header = getheader()
  return dispatch => {

    dispatch({
      type: "LOADING",
      data: true
    })
    data = JSON.stringify(data)
    fetch(serverUrl + "ReceptionTasksApi/AddCustomerRequest/", {
      body: data,
      headers: _header,
      method: 'POST',
    })
      .then(res => res.json())
      .then(res => {

        dispatch({
          type: "LOADING",
          data: false
        });
        if (res.Message) {
          alert("اشکال در انجام عملیات");
          return;
        }
        let serviceInfo = JSON.parse(data);
        localStorage.setItem("LastServiceType", serviceInfo.ServiceType);
        localStorage.setItem("LastServiceID", res);
        if (!isNaN(res)) {
          fn(res, serviceInfo.ServiceType);
        }
        return dispatch({
          type: "ADD_SERVICE",
          data: res
        })
      }
      ).catch(err => {
        console.error('[ADD_SERVICE]', err);
        dispatch({
          type: "LOADING",
          data: false
        });
      });
  };
}
////////////////////////////////////////////////////////////////////
export function getTaskList(data) {
  //const _header = getHeaderGet();
  var token = localStorage.getItem('token')
  return dispatch => {
    dispatch({
      type: "GET_TASKS",
      data: "PENDING"
    });
    fetch(serverUrl + "ReceptionTasksApi/GetCustomerRequestList", {
      headers: getheader(),
      method: 'POST',
      body: JSON.stringify(data)
    }).then(res => res.json())
      .then(res => {
        if (res.Message && res.Message === "Error") {
          alert("اشکال در بازیابی اطلاعات");
          return;
        }
        return dispatch({
          type: "GET_TASKS",
          data: res
        })

      }).catch(err => {
        console.error('[err]', err);
        return dispatch({
          type: "GET_TASKS",
          data: null
        })
      });

  };
}
////////////////////////////////////////////////////////////////////////////////////
export function resetRejectedService(serviceType, serviceID, fn) {
  return dispatch => {
    dispatch({
      type: "LOADING",
      data: true
    });
    fetch(serverUrl + "ReceptionTasksApi/ResetRejectedService?serviceType=" + serviceType + "&&serviceID=" + serviceID, {
      method: "GET",
      catch: "default"
    }).then(res => res.json())
      .then(res => {
        dispatch({
          type: "LOADING",
          data: false
        });
        fn();
        return dispatch({
          type: "RESET_SERVICE",
          data: res === "Success" ? true : false
        });
      }).catch(e =>
        console.log("[ResetRejectedService]", e))
  }
}
////////////////////////////////////////////////////////////////////
export function getCustomerLastRequest(serviceType, serviceID) {
  let token = localStorage.getItem('token');
  return dispatch => {
    if (serviceType === null || serviceType === '' || serviceType === undefined || serviceID === '' || serviceID === undefined || serviceID === null) {
      return dispatch({
        type: "GET_LAST_TASK",
        data: "NotFound"
      })
    }
    dispatch({
      type: "GET_LAST_TASK",
      data: "Pending"
    })
    fetch(serverUrl + "ReceptionTasksApi/GetCustomerLastRequest?serviceType=" + serviceType + "&&serviceID=" + serviceID, {
      headers: {
        "token": token,

      },
      method: 'GET',
      cache: 'default'
    }).then(res => res.json())
      .then(res => {
        dispatch({
          type: "LOADING",
          data: false
        })
        if (res.Message && res.Message === "Error") {
          alert("اشکال در بازیابی اطلاعات");
          return;
        }
        if (res === "NotFound") {
          localStorage.removeItem("LastServiceID");
          localStorage.removeItem("LastServiceType");
        }
        return dispatch({
          type: "GET_LAST_TASK",
          data: res
        })

      }).catch(err => {
        console.error('[err]', err);
        dispatch({
          type: "LOADING",
          data: false
        });
        alert("اشکال در بازیابی اطلاعات");
      });
  }

};
////////////////////////////////////////////////////////////////////
export function getServiceInvoice(serviceType, serviceID) {
  let token = localStorage.getItem('token');
  return dispatch => {
    dispatch({
      type: "LOADING",
      data: true
    });
    fetch(serverUrl + "ReceptionTasksApi/GetServiceInvoice?serviceID=" + serviceID + "&serviceType=" + serviceType, {
      headers: {
        "token": token
      },
      method: 'GET',
      cache: 'default'
    }).then(res => res.json())
      .then(res => {
        dispatch({
          type: "LOADING",
          data: false
        })
        if (res.Message && res.Message === "Error") {
          alert("اشکال در بازیابی اطلاعات");
          return;
        }
        return dispatch({
          type: "GET_SERVICE_INVOICE",
          data: res
        })

      }).catch(err => {
        console.error('[GET_SERVICE_INVOICE]', err);
        dispatch({
          type: "LOADING",
          data: false
        });
        alert("اشکال در بازیابی اطلاعات");
      });
  }

};
////////////////////////////////////////////////////////////////////
export function deleteService(serviceType, serviceID, fn) {
  let token = localStorage.getItem('token');
  return dispatch => {
    if (serviceType === null || serviceType === '' || serviceType === undefined || serviceID === '' || serviceID === undefined || serviceID === null) {
      return dispatch({
        type: "DELETE_SERVICE",
        data: "NotFound"
      })
    }
    fetch(serverUrl + "ReceptionTasksApi/DeleteService?serviceType=" + serviceType + "&&serviceID=" + serviceID, {
      headers: {
        "token": token
      },
      method: 'GET',
      cache: 'default'
    }).then(res => res.json())
      .then(res => {
        dispatch({
          type: "LOADING",
          data: false
        })
        if (res.Message) {
          setErrorDialog(dispatch, res.Message, "لغو درخواست");
          return;
        }
        else {
          setErrorDialog(dispatch, "success", "لغو درخواست");
          if (fn) {
            fn();
          }
        }


      }).catch(err => {
        console.error('[DELETE_SERVICE]', err);
        dispatch({
          type: "LOADING",
          data: false
        });
        setErrorDialog(dispatch, "error", "لغو درخواست");
      });
  }

};
export function attachFile(fileInput, parentID, attachmentType, fn, moreInfo) {
  if (fileInput.files.length === 0) {
    if (fn) {
      fn();
    }
    return;
  }
  var formdata = new FormData();
  for (let i = 0; i < fileInput.files.length; i++) {
    formdata.append(fileInput.files[i].name, fileInput.files[i]);
    formdata.append("ParentID", parentID);
    formdata.append("AttachmentType", attachmentType);
  }
  if (moreInfo) {
    formdata.append("moreInfo", moreInfo);
  }
  var xhr = new XMLHttpRequest();
  xhr.open('POST', serverUrl + 'api/Attachments/Upload', true);
  xhr.setRequestHeader("token", localStorage.getItem("token"));
  xhr.setRequestHeader("NameIsUniq", true);
  xhr.send(formdata);
  xhr.onreadystatechange = function () {
    if (xhr.readyState === 4 && xhr.status === 200) {
      var response = JSON.parse(xhr.responseText);
      if (response.Message !== "Error") {
        alert("بارگذاری با موفقیت انجام شد");
        if (fn)
          fn();
      }
      else {
        alert("اشکال در آپلود فایل");
      }

    }
    return "UnExpected Error";

  };
}
export function downloadFile(itemID, attachmentType) {
  // window.open(serverUrl + `api/Attachments/DownloadAttachment?id=${itemID}&attachmentType=${attachmentType}`, "download");
  fetch(serverUrl + `api/Attachments/DownloadAttachment?id=${itemID}&attachmentType=${attachmentType}`,
    {
      headers: {
        'Content-Type': 'blob',
        'token': localStorage.getItem("token")
      }
      , method: "get"
    })
    .then((response) => {
      response.blob()
        .then((blob) => {
          if (blob.type === "application/json") {
            return;
          }
          var a = document.createElement("a");
          a.href = window.URL.createObjectURL(blob);
          a.download = "Download";
          a.click();
        })
    })
}
export function getServiceStatusList(onGetData) {
  onGetData("PENDING");
  fetch(serverUrl + "ReceptionTasksApi/GetServiceStatusList", {
    headers: getheader(),
    method: "GET",
    cache: "default"
  }).then(res => res.json()).then(res => {
    if (res === "Error" || res.Message) {
      res = null;
    }
    onGetData(res);
  }).catch(e => {
    console.log("[GET_SERVICE_STATUS]", e);
    onGetData(null);
  })
}
export function loadFaultsByCustomer(name) {
  return dispatch => {
    dispatch({
      type: "LOAD_FAULTS_CUSTOMER",
      data: "PENDING"
    });
    fetch(serverUrl + `ReceptionTasksApi/LoadFaultsByCustomer?name=${name}`, {
      headers: getheader(),
      method: "GET",
      cache: "default"
    }).then(res => res.json())
      .then(res => {
        if (res === "Error" || res.Message) {
          setErrorDialog(dispatch, res?.Message ?? res, "لیست ایراد");
          res = []
        }
        dispatch({
          type: "LOAD_FAULTS_CUSTOMER",
          data: res
        })
      }).catch(e =>
        dispatch({
          type: "LOAD_FAULTS_CUSTOMER",
          data: null
        })
      )
  }
}
export function addCustomerRequestWithoutLogin(data, onPost) {
  return dispatch => {
    fetch(serverUrl + `api/CustomersAPI/AddCustomerRequestWithoutLogin`, {
      method: "POST",
      body: JSON.stringify(data),
      headers: getheader()
    }).then(res => res.json())
      .then(res => {
        if (res.Message) {
          setErrorDialog(dispatch, res.Message, "درخواست سریع");
        }
        else if (res.ID) {
          setErrorDialog(dispatch, "درخواست شما با کد " + res.ID + " در سیستم ثبت شد");
          if (onPost) {
            onPost(res);
          }
        }
      })
  }
}

// export function validateCaptcha(captchaTextEl, createAgain) {
//   if (captchaTextEl.value == code) {
//     return true;
//   } else {
    
//     createAgain();
//   }
//}
